export default {
    Content1: "Sharing knowledge, experience, and 'insider secrets' in the testing profession, providing consultation, career orientation, and offering courses for Mobile, Website, API, and performance testing by experts with many years of experience.",
    Content2: "Website: https://testek.vn",
    Content3: "Hotline (Zalo): 0946210891",
    Content4: "Courses provided by Testek:",
    Content5: "At Testek:",
    Content6: "Instructors are leading industry experts",
    Content7: "Learn to do, NOT just to know",
    Content8: "Career orientation",
    Content9: "Learning materials at Testek:",
    Content10: "API System:",
}